import React, { useRef } from "react";
import { motion, useInView } from "framer-motion";
import "./Erkenning.css";
import Baloise from "../../assets/img/erkenningen/Baloise.png";
import Belfius from "../../assets/img/erkenningen/Belfius.jpg";
import Allianz from "../../assets/img/erkenningen/Allianz.jpg";
import Dvv from "../../assets/img/erkenningen/Dvv.jpg";
import NN from "../../assets/img/erkenningen/NN.jpg";
import YUZZU from "../../assets/img/erkenningen/YUZZU.png";
import AXA from "../../assets/img/erkenningen/AXA.png";
import AG from "../../assets/img/erkenningen/AG.0290bba3ce408ce766b3-removebg-preview.png";
import KBC from "../../assets/img/erkenningen/cq5dam.web.480.9999.png";
import Vivium from "../../assets/img/erkenningen/vivium-pv.png";
import Ethias from "../../assets/img/erkenningen/Ethias.png";
import Argenta from "../../assets/img/erkenningen/Argenta.png";

const LUXURY = [0.16, 1, 0.3, 1];

const erkend = [
  // Row 1 — three wide tiles (2+2+2 = 6)
  { name: "AG Insurance", img: AG,      spanCol: 2 },
  { name: "Baloise",      img: Baloise, spanCol: 2 },
  { name: "Allianz",      img: Allianz, spanCol: 2 },
  // Row 2 — dense narrow + one accent (1+1+2+1+1 = 6)
  { name: "Belfius",      img: Belfius, spanCol: 1 },
  { name: "KBC",          img: KBC,     spanCol: 1 },
  { name: "Ethias",       img: Ethias,  spanCol: 2 },
  { name: "NN",           img: NN,      spanCol: 1 },
  { name: "DVV",          img: Dvv,     spanCol: 1 },
  // Row 3 — asymmetric bookend (1+2+2+1 = 6)
  { name: "Argenta",      img: Argenta, spanCol: 1 },
  { name: "YUZZU",        img: YUZZU,   spanCol: 2 },
  { name: "AXA",          img: AXA,     spanCol: 2 },
  { name: "Vivium",       img: Vivium,  spanCol: 1 },
];

const headerVariants = {
  hidden: {},
  visible: { transition: { staggerChildren: 0.18 } },
};

const lineVariant = {
  hidden:  { opacity: 0, y: 20 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.8, ease: LUXURY } },
};

const tileVariant = (i) => ({
  hidden:  { opacity: 0, scale: 0.98 },
  visible: {
    opacity: 1,
    scale: 1,
    transition: { duration: 0.6, delay: i * 0.05, ease: LUXURY },
  },
});

export default function Erkenning() {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-10%" });

  return (
    <section id="erkenning" className="erkenning-section" ref={ref}>
      <div className="erkenning-container">

        <motion.div
          className="erkenning-header"
          variants={headerVariants}
          initial="hidden"
          animate={isInView ? "visible" : "hidden"}
        >
          <span className="section-badge">Erkenningen</span>
          <motion.h2 className="erkenning-title" variants={lineVariant}>
            Onze erkenningen
          </motion.h2>
          <motion.p className="erkenning-subtitle" variants={lineVariant}>
            Wij zijn erkend hersteller voor diverse verzekeringsmaatschappijen in België.
          </motion.p>
        </motion.div>

        <div className="erkenning-bento-grid">
          {erkend.map((item, i) => (
            <motion.div
              key={item.name}
              className="erkenning-tile"
              style={{
                gridColumn: `span ${item.spanCol}`,
              }}
              variants={tileVariant(i)}
              initial="hidden"
              animate={isInView ? "visible" : "hidden"}
            >
              <div className="logo-container">
                <img
                  src={item.img}
                  alt={`${item.name} – erkend hersteller`}
                  className="logo-image"
                  loading="lazy"
                />
              </div>
            </motion.div>
          ))}
        </div>

      </div>
    </section>
  );
}
